import { HeaderTypes } from './types';

// styles
import './header.css';

export default function Header({
  className,
  children,
}: HeaderTypes): React.JSX.Element {
  return <div className={`header ${className || ''}`}>{children}</div>;
}
